let React            = require("react");
let ImportUtil       = require("../../util/ImportUtil.js");
let UploadFileButton = require("./generic/UploadFileButton.jsx");

class Upload3DModelButton extends React.Component {

    constructor(){
        super()

        this.onUpload = this.onUpload.bind(this)
    }

    onUpload(files){
        let {setLoading, idHub, onComplete, handleError} = this.props
        let promise = Promise.resolve();
        
        let numFiles = files.length;
        let i = 1;

        for (const file of files) {
            if(ImportUtil.validateFile(file, /.*\.(step|stp|f3d)$/i)) {
                setLoading(true, `Uploading ${numFiles} file${(numFiles > 1)?'s':''}`);
                let onProgress = (text) => {
                  setLoading(true, text + ((numFiles > 1)?` (file ${i}/${numFiles})`:''));
                  i++;
                }
                promise = promise.then(()=> {
                  return ImportUtil.createResource3D(handleError, file, onProgress, {hub: idHub})
                  // add in a small delay after uploading each file. this is to keep the cs from being hit too hard,
                  // and to give a second for tranlations to start if needed.
                }).then(() => new Promise((resolve, reject)=>{
                  setTimeout(()=> resolve(), 500);
                }))
            } else {
                handleError(null, 'upload this file', 'Please check that the file extension is STEP, STP, or F3D.')
                setLoading(false)
            }
        }

        Promise.resolve(promise)
            .then(() => {setLoading(false); onComplete();})
            //it is necessary in order to update the 3D model's view
            .catch(() => {setLoading(false); onComplete();})
    }

    render() {
        return  <UploadFileButton
                    multiple
                    accept=".step, .stp , .f3d"
                    onUpload={this.onUpload}
                    text="Upload 3D Model"
                    addedClass="space-below"
                />
    }
}

module.exports = Upload3DModelButton;
